// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"ListingTypesInput_chipsContainer__mnnB8","placeHolder":"ListingTypesInput_placeHolder__dzxCQ"};